
<template>
  <div class="temp_set_warper">
    <div class="temp_set_title">预设温度</div>
    <div class="temp_set_content">
      <span class="temp_set_content_btn" @click="clickDecreaseBtnHandle" >一</span>
      <span class="temp_set_content_var">一 {{dvalue}}° 一</span>
      <span class="temp_set_content_btn" @click="clickIncreaseBtnHandle">十</span>
    </div>
    <div class="temp_set_tips">
      <span class="temp_set_tips_left">16°</span>
      <span class="temp_set_tips_right">30°</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dvalue: this.value
    }
  },
  props: {
    value: {
      type: Number,
      default: 24
    }
  },
  methods: {
    clickIncreaseBtnHandle() {
      if (this.dvalue >= 30) {
        this.dvalue = 30
      } else {
        this.dvalue++
      }
      console.log(this.dvalue)
      this.$emit('valueChange', this.dvalue)
    },
    clickDecreaseBtnHandle() {
      if (this.dvalue <= 16) {
        this.dvalue = 16
      } else {
        this.dvalue--
      }
      this.$emit('valueChange', this.dvalue)
    }
  },
  watch: {
    value(val) {
      console.log(val)
      this.dvalue = val
      this.$emit('valueChange', this.dvalue)  ///这里回传是为了解决数据不同步的问题，详见印象笔记服务器数据Sdata与组件数据的同步
    }
  }
}

/*
使用方法示例
    <temp-set :value="varNumber" @valueChange="tempValueChange"></temp-set>
    父组件可以定义变量数据传递给组件当前设置值 value 如varNumber
    父组件中创建tempValueChange方法接收温度值的变化 如下
        tempValueChange(data) {
      console.log("子组件传回的值" + data);
      this.ControlSwitchBtnState=data;
    },
    */
</script>

<style>
.temp_set_warper {
  width: 260px;
  height: 85px;
  /* border: 1px solid blue; */

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  justify-content: flex-start;

  align-items: center;
}
.temp_set_title {
  font-size: 14px;
  color: #999999;
}
.temp_set_content_btn {
  display: inline-block;
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* font-size: 25px; */
  border: 1px solid var(--control-outline-color);

  border-radius: 4px;
}
.temp_set_content_btn:active {
  background: #a0a3a5;
}
.temp_set_content_var {
  display: inline-block;
  width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 20px;
  text-align: center;

  margin: 0px 26px;
}
.temp_set_tips {
  margin: 5px 0px;
  font-size: 14px;
  color: #999999;
}
.temp_set_tips_left {
  margin-right: 92px;
}
.temp_set_tips_right {
  margin-left: 92px;
}
</style>



